module.exports = __webpack_public_path__ + "static/media/cipher.4452c23e.png";